<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>

        <div class="tab-headers-container">
          <div
            class="tab-header"
            pRipple
            (click)="setActiveTab('manage')"
            [class.active]="activeTab === 'manage'"
          >
            <span class="material-symbols-outlined icon">list</span>
            <span class="label">{{ t("management") }}</span>
          </div>
          @if (canViewAutomations) {
            <div
              class="tab-header"
              pRipple
              (click)="setActiveTab('automations')"
              [class.active]="activeTab === 'automations'"
            >
              <span class="material-symbols-outlined icon">bolt</span>
              <span class="label">{{ t("automations") }}</span>
            </div>
          }
        </div>
      </div>

      <div class="tab-panels-container">
        <div class="tab-panel" [class.visible]="activeTab === 'manage'">
          <div class="actions-row">
            <p-button
              [icon]="
                'pi pi-refresh' +
                (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
              "
              [disabled]="dataLoading$ | async"
              (click)="refreshData()"
            />

            <p-button
              icon="pi pi-filter"
              severity="info"
              [outlined]="!filtersDialogVisible"
              [disabled]="dataLoading$ | async"
              (click)="toggleFilters()"
              [label]="appliedFiltersCount"
            />

            <input
              #dataSearch
              type="text"
              pInputText
              id="search-input"
              (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
              [placeholder]="t(SEARCH_PLACEHOLDER)"
              class="search-input"
            />

            @if (selectedRows.length == 1) {
              @let selRow = selectedRows[0];

              @if (selRow.status === "CREATED" || selRow.status === "TOOK_ON") {
                <p-button
                  [label]="t('startTask')"
                  icon="pi pi-play"
                  class="set-status-button in-progress"
                  (click)="updateTaskStatus(selRow, 'IN_PROGRESS')"
                  severity="help"
                  [outlined]="true"
                />

                <p-button
                  [label]="t('cancelTask')"
                  icon="pi pi-stop"
                  class="set-status-button cancel"
                  (click)="updateTaskStatus(selRow, 'CANCELED')"
                  severity="danger"
                  [outlined]="true"
                />
              } @else if (selRow.status === "IN_PROGRESS") {
                <p-button
                  [label]="t('completeTask')"
                  icon="pi pi-check"
                  class="set-status-button complete"
                  (click)="updateTaskStatus(selRow, 'COMPLETED')"
                  severity="success"
                  [outlined]="true"
                />
              }
            }

            <p-button
              [label]="t(ADD_BUTTON_LABEL)"
              icon="pi pi-plus"
              class="add-record-button"
              (click)="openFormDialog()"
            />

            <p-button
              icon="pi pi-list-check"
              severity="secondary"
              [disabled]="selectedRows.length === 0"
              (click)="batchMenuElement.toggle($event)"
            />

            <p-menu
              #batchMenuElement
              [model]="batchMenu"
              [popup]="true"
              appendTo="body"
            />
          </div>

          <p-skeleton
            class="skeleton-loader"
            height="100%"
            width="100%"
            [class.visible]="(dataLoadingUI$ | async) ?? true"
          />

          <p-table
            #dataTable
            class="table"
            id="table"
            [value]="data"
            [(selection)]="selectedRows"
            [rowHover]="true"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
            sortMode="single"
            selectionMode="multiple"
            [rowTrackBy]="_dataTrackBy"
            [metaKeySelection]="true"
            [resizableColumns]="true"
            columnResizeMode="fit"
            [globalFilterFields]="dataFilterFields"
            stripedRows
            [scrollable]="true"
            [class.visible]="!((dataLoadingUI$ | async) ?? true)"
            sortField="creationDate"
            [sortOrder]="-1"
          >
            <ng-template #header>
              <tr>
                <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

                @for (col of columns; track col.field) {
                  @if (col.visible ?? true) {
                    <th [pSortableColumn]="col.field" pResizableColumn>
                      <div class="table-header-row">
                        <span class="header-label">{{
                          t(col.header, col.headerParams)
                        }}</span>
                        <div class="header-buttons">
                          <p-sortIcon [field]="col.field" />
                        </div>
                      </div>
                    </th>
                  }
                }
              </tr>
            </ng-template>
            <ng-template #body let-record let-rowIndex="rowIndex">
              <tr
                [pSelectableRow]="record"
                [pSelectableRowIndex]="rowIndex"
                (contextmenu)="$event.preventDefault(); openFormDialog(record)"
                (longPress)="openFormDialog(record)"
                appLongPress
              >
                <td (click)="$event.stopPropagation()">
                  <p-tableCheckbox [value]="record" />
                </td>
                @for (col of columns; track col.field) {
                  @if (col.visible ?? true) {
                    <td>
                      <!-- CELLA -->
                      @if (col.wrapper) {
                        <ng-container
                          *ngComponentOutlet="
                            col.wrapper;
                            inputs: parseWrapperInputs(col, [
                              record,
                              getCellData(col, record),
                            ])
                          "
                        ></ng-container>
                      } @else {
                        <span [innerHTML]="getCellData(col, record)"></span>
                      }
                    </td>
                  }
                }
              </tr>
            </ng-template>
          </p-table>
        </div>

        @if (canViewAutomations) {
          <div class="tab-panel" [class.visible]="activeTab === 'automations'">
            <div class="actions-row">
              <p-button
                [icon]="
                  'pi pi-refresh' + ((dataLoading2$ | async) ? ' pi-spin' : '')
                "
                [disabled]="dataLoading2$ | async"
                (click)="refreshData2()"
              />

              <p-button
                icon="pi pi-filter"
                severity="info"
                [outlined]="!filtersDialogVisible2"
                [disabled]="dataLoading2$ | async"
                (click)="toggleFilters2()"
                [label]="appliedFiltersCount2"
              />

              <input
                #dataSearch2
                type="text"
                pInputText
                id="search-2-input"
                (input)="dataTable2.filterGlobal(dataSearch2.value, 'contains')"
                [placeholder]="t(SEARCH_PLACEHOLDER2)"
                class="search-input"
              />

              <p-button
                [label]="t(ADD_BUTTON_LABEL2)"
                icon="pi pi-plus"
                class="add-record-button"
                (click)="openFormDialog2()"
              />

              <p-button
                icon="pi pi-list-check"
                severity="secondary"
                [disabled]="selectedRows2.length === 0"
                (click)="batchMenuElement2.toggle($event)"
              />

              <p-menu
                #batchMenuElement2
                [model]="batchMenu2"
                [popup]="true"
                appendTo="body"
              />
            </div>

            <p-skeleton
              class="skeleton-loader"
              height="100%"
              width="100%"
              [class.visible]="(dataLoadingUI2$ | async) ?? true"
            />

            <p-table
              #dataTable2
              class="table"
              id="table2"
              [value]="data2"
              [(selection)]="selectedRows2"
              [rowHover]="true"
              [paginator]="true"
              [rows]="10"
              [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
              sortMode="single"
              selectionMode="multiple"
              [rowTrackBy]="_dataTrackBy2"
              [metaKeySelection]="true"
              [resizableColumns]="true"
              columnResizeMode="fit"
              [globalFilterFields]="dataFilterFields2"
              stripedRows
              [scrollable]="true"
              [class.visible]="!((dataLoadingUI2$ | async) ?? true)"
            >
              <ng-template #header>
                <tr>
                  <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

                  @for (col of columns2; track col.field) {
                    @if (col.visible ?? true) {
                      <th [pSortableColumn]="col.field" pResizableColumn>
                        <div class="table-header-row">
                          <span class="header-label">{{
                            t(col.header, col.headerParams)
                          }}</span>
                          <div class="header-buttons">
                            <p-sortIcon [field]="col.field" />
                          </div>
                        </div>
                      </th>
                    }
                  }
                </tr>
              </ng-template>
              <ng-template #body let-record let-rowIndex="rowIndex">
                <tr
                  [pSelectableRow]="record"
                  [pSelectableRowIndex]="rowIndex"
                  (contextmenu)="
                    $event.preventDefault(); openFormDialog2(record)
                  "
                  (longPress)="openFormDialog2(record)"
                  appLongPress
                >
                  <td (click)="$event.stopPropagation()">
                    <p-tableCheckbox [value]="record" />
                  </td>
                  @for (col of columns2; track col.field) {
                    @if (col.visible ?? true) {
                      <td>
                        <!-- CELLA -->
                        @if (col.wrapper) {
                          <ng-container
                            *ngComponentOutlet="
                              col.wrapper;
                              inputs: parseWrapperInputs(col, [
                                record,
                                getCellData(col, record),
                              ])
                            "
                          ></ng-container>
                        } @else {
                          <span [innerHTML]="getCellData(col, record)"></span>
                        }
                      </td>
                    }
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="
      isNewRecordDialog
        ? t(NEW_RECORD_TITLE)
        : t(EDIT_RECORD_TITLE, { code: formDialogData.code })
    "
    [modal]="true"
    [(visible)]="formDialogVisible"
    [style]="{ width: 'min(35rem, 90vw)', height: 'min(85vh, 700px)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
    (onHide)="dialogForm.reset(formDialogData); activeEditSection = 'data'"
  >
    @if (!isNewRecordDialog) {
      <div class="buttons-row">
        <p-button
          [label]="t('data')"
          icon="pi pi-pencil"
          [severity]="activeEditSection == 'data' ? 'primary' : 'secondary'"
          [rounded]="true"
          size="small"
          (click)="activeEditSection = 'data'"
        />

        <p-button
          [label]="t('history')"
          icon="pi pi-clock"
          [severity]="activeEditSection == 'history' ? 'primary' : 'secondary'"
          [rounded]="true"
          size="small"
          (click)="activeEditSection = 'history'"
        />

        <p-button
          [label]="t('actionDetails')"
          icon="pi pi-info-circle"
          [severity]="
            activeEditSection == 'actionDetails' ? 'primary' : 'secondary'
          "
          [rounded]="true"
          size="small"
          (click)="activeEditSection = 'actionDetails'"
        />
      </div>
    }

    <form
      class="dialog-form"
      [class.visible]="activeEditSection == 'data'"
      #dialogForm="ngForm"
    >
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #taskCodeInput="ngModel"
          pInputText
          id="task-code-input"
          name="code"
          [(ngModel)]="formDialogData.code"
          autocomplete="off"
          required
          [disabled]="((dataLoading$ | async) ?? true) || !canEditTask"
        />
        <label for="task-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? BIKE ---------------------------->
      <p-floatlabel variant="in">
        <p-select
          #bikeInput="ngModel"
          inputId="task-bike-input"
          name="bike"
          [(ngModel)]="formDialogData.bike"
          autocomplete="off"
          [disabled]="((dataLoading$ | async) ?? true) || !canEditTask"
          [options]="bikes"
          optionLabel="code"
          optionValue="bikeId"
          appendTo="body"
          styleClass="w-full"
          required
          [filter]="true"
          filterBy="code"
        />
        <label for="task-bike-input">
          {{ t("bike") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? TYPE ---------------------------------->
      <p-floatlabel variant="in">
        <p-select
          #taskTypeInput="ngModel"
          inputId="task-type-input"
          name="type"
          [(ngModel)]="formDialogData.type"
          autocomplete="off"
          [disabled]="((dataLoading$ | async) ?? true) || !canEditTask"
          [options]="types"
          optionLabel="description"
          optionValue="code"
          appendTo="body"
          styleClass="w-full"
          required
          [filter]="true"
          filterBy="description"
        />
        <label for="task-type-input">
          {{ t("type") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? ACTION ---------------------------------->
      <p-floatlabel variant="in">
        <p-select
          #taskActionInput="ngModel"
          inputId="task-action-input"
          name="action"
          [(ngModel)]="formDialogData.action"
          autocomplete="off"
          [disabled]="((dataLoading$ | async) ?? true) || !canEditTask"
          [options]="actions"
          optionLabel="code"
          optionValue="actionId"
          appendTo="body"
          styleClass="w-full"
          required
          [filter]="true"
          filterBy="description"
        />
        <label for="task-action-input">
          {{ t("action") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? STATUS ---------------------------------->
      <p-floatlabel variant="in">
        <p-select
          #taskStatusInput="ngModel"
          inputId="task-status-input"
          name="status"
          [(ngModel)]="formDialogData.status"
          autocomplete="off"
          [disabled]="((dataLoading$ | async) ?? true) || !canEditTask"
          [options]="statuses"
          optionLabel="description"
          optionValue="code"
          appendTo="body"
          styleClass="w-full"
          required
          [filter]="true"
          filterBy="description"
        />
        <label for="task-status-input">
          {{ t("status") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? NOTES ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          #taskNotesInput="ngModel"
          id="task-notes-input"
          name="notes"
          [(ngModel)]="formDialogData.notes"
          autocomplete="off"
          [disabled]="((dataLoading$ | async) ?? true) || !canEditTask"
          styleClass="w-full"
          rows="4"
          style="resize: none"
        ></textarea>
        <label for="task-notes-input">
          {{ t("notes") }}
        </label>
      </p-floatlabel>
    </form>

    <div
      class="dialog-history"
      [class.visible]="activeEditSection == 'history'"
    >
      <div class="history-container">
        @for (
          history of formDialogData.history ?? [];
          track history.historyId
        ) {
          <div class="history-element">
            <div class="profile-picture">
              @if (history.modifiedByDetails.picture) {
                <img
                  [src]="history.modifiedByDetails.picture"
                  [alt]="t('profilePicture')"
                />
              } @else {
                <span class="material-symbols-outlined">person</span>
              }
            </div>

            <div class="col-info">
              <p class="username">{{ history.modifiedByDetails.username }}</p>
              <span class="time">{{
                history.modifiedAt | translocoDate: { timeStyle: "short" }
              }}</span>
              <span class="time">{{
                history.modifiedAt | translocoDate: { dateStyle: "short" }
              }}</span>
            </div>

            <div class="col-edit">
              <p
                class="has-edited-label"
                [innerHTML]="
                  history.field == 'CREATED'
                    ? t('hasCreatedTask')
                    : t('hasEditedField', { field: t(history.field) })
                "
              ></p>

              @if (history.field != "CREATED") {
                <p
                  class="old-value"
                  [innerHTML]="parseHistoryValue(history, 'old')"
                ></p>
                <p
                  class="new-value"
                  [innerHTML]="parseHistoryValue(history, 'new')"
                ></p>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div
      class="dialog-actionDetails"
      [class.visible]="activeEditSection == 'actionDetails'"
    >
      @let actionData = getActionData(formDialogData.action);
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          pInputText
          id="task-action-code-input"
          [ngModel]="actionData?.code"
          [readonly]="true"
        />
        <label for="task-action-code-input">
          {{ t("code") }}
        </label>
      </p-floatlabel>

      <!--? NOTES ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          id="task-action-notes-input"
          [ngModel]="actionData?.notes"
          autocomplete="off"
          [readonly]="true"
          styleClass="w-full"
          rows="4"
          style="resize: none"
        ></textarea>
        <label for="task-action-notes-input">
          {{ t("notes") }}
        </label>
      </p-floatlabel>

      <!--? LINK ----------------------------->
      <p-inputgroup>
        <p-floatlabel variant="in">
          <input
            pInputText
            id="task-action-link-input"
            [ngModel]="actionData?.link"
            [readonly]="true"
          />
          <label for="task-action-link-input">
            {{ t("link") }}
          </label>
        </p-floatlabel>
        @if (actionData?.link) {
          <p-inputgroup-addon>
            <p-button
              icon="pi pi-link"
              severity="secondary"
              variant="text"
              (click)="openLink(actionData?.link)"
              styleClass="h-full"
            />
          </p-inputgroup-addon>
        }
      </p-inputgroup>
    </div>

    <ng-template #footer>
      @if (!isNewRecordDialog && canDeleteTask) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteRecord()"
          class="delete-button"
          [outlined]="true"
          [disabled]="(dataLoading$ | async) ?? true"
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideFormDialog()"
        [outlined]="true"
      />
      @if (canEditTask) {
        <p-button
          [label]="t('save')"
          severity="primary"
          (click)="saveRecord()"
          [disabled]="((dataLoading$ | async) ?? true) || !dialogForm.valid"
        />
      }
    </ng-template>
  </p-dialog>

  <!--? FORM DIALOG 2  --------------------------------->
  <p-dialog
    [header]="
      isNewRecordDialog2
        ? t(NEW_RECORD_TITLE2)
        : t(EDIT_RECORD_TITLE2, { code: formDialogData2.code })
    "
    [modal]="true"
    [(visible)]="formDialogVisible2"
    [style]="{ width: 'min(35rem, 90vw)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
    (onHide)="dialogForm2.reset(formDialogData2)"
  >
    <form class="dialog-form visible" #dialogForm2="ngForm">
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #automationCodeInput="ngModel"
          pInputText
          id="automation-code-input"
          name="code"
          [(ngModel)]="formDialogData2.code"
          autocomplete="off"
          required
          [disabled]="(dataLoading2$ | async) ?? true"
        />
        <label for="automation-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? ACTION ---------------------------------->
      <p-floatlabel variant="in">
        <p-select
          #automationActionInput="ngModel"
          inputId="automation-action-input"
          name="action"
          [(ngModel)]="formDialogData2.action"
          autocomplete="off"
          [disabled]="(dataLoading2$ | async) ?? true"
          [options]="actions"
          optionLabel="code"
          optionValue="actionId"
          appendTo="body"
          styleClass="w-full"
          required
          [filter]="true"
          filterBy="description"
        />
        <label for="automation-action-input">
          {{ t("action") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? MODELS ---------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #bikeModelInput="ngModel"
          inputId="bike-model-input"
          name="model"
          [(ngModel)]="formDialogData2.models"
          autocomplete="off"
          [disabled]="(dataLoading2$ | async) ?? true"
          [options]="bikesModels"
          optionLabel="code"
          optionValue="modelId"
          appendTo="body"
          styleClass="w-full"
          required
        />
        <label for="bike-model-input">
          {{ t("models") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? DESCRIPTION ------------------------>
      <p-floatlabel variant="in">
        <input
          #automationDescriptionInput="ngModel"
          pInputText
          id="automation-description-input"
          name="description"
          [(ngModel)]="formDialogData2.description"
          autocomplete="off"
          [disabled]="(dataLoading2$ | async) ?? true"
        />
        <label for="automation-description-input">
          {{ t("description") }}
        </label>
      </p-floatlabel>

      <!--? TRIGGER TYPE ------------------------>
      <p-floatlabel variant="in">
        <p-select
          #automationTriggerTypeInput="ngModel"
          inputId="automation-trigger-type-input"
          name="triggerType"
          [(ngModel)]="formDialogData2.triggerType"
          autocomplete="off"
          [disabled]="(dataLoading2$ | async) ?? true"
          [options]="automationsTriggers"
          optionLabel="description"
          optionValue="code"
          appendTo="body"
          styleClass="w-full"
          required
        />

        <label for="automation-trigger-type-input">
          {{ t("triggerType") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? TRIGGER VALUE ------------------------>
      <p-floatlabel variant="in">
        <p-inputnumber
          #automationTriggerValueInput="ngModel"
          inputId="automation-trigger-value-input"
          name="triggerValue"
          [(ngModel)]="formDialogData2.triggerValue"
          autocomplete="off"
          required
          [disabled]="(dataLoading2$ | async) ?? true"
          [min]="0"
          [showButtons]="true"
          buttonLayout="stacked"
        />
        <label for="automation-trigger-value-input">
          {{ t("triggerValue") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      @if (!isNewRecordDialog2) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteRecord2()"
          class="delete-button"
          [outlined]="true"
          [disabled]="(dataLoading2$ | async) ?? true"
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideFormDialog2()"
        [outlined]="true"
      />
      <p-button
        [label]="t('save')"
        severity="primary"
        (click)="saveRecord2()"
        [disabled]="((dataLoading2$ | async) ?? true) || !dialogForm2.valid"
      />
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t(FILTERS_TITLE)"
    [(visible)]="filtersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide()"
  >
    <form class="filter-form" #filterForm="ngForm">
      <!--? STATUS ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #taskFilterStatusInput="ngModel"
          inputId="task-filter-status"
          name="task-filter-status"
          appendTo="body"
          [options]="
            translateObjectValues(dataFilters.options.status, 'description')
          "
          [(ngModel)]="dataFilters.values.status"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
          optionLabel="description"
          optionValue="code"
        />
        <label for="task-filter-status">
          {{ t("status") }}
        </label>
      </p-floatlabel>

      <!--? TYPE ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #taskFilterTypeInput="ngModel"
          inputId="task-filter-type"
          name="task-filter-type"
          appendTo="body"
          [options]="
            translateObjectValues(dataFilters.options.type, 'description')
          "
          [(ngModel)]="dataFilters.values.type"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
          optionLabel="description"
          optionValue="code"
        />
        <label for="task-filter-type">
          {{ t("type") }}
        </label>
      </p-floatlabel>

      <!--? CREATION DATE ----------------------------->
      <p-floatlabel variant="in">
        <p-datepicker
          #taskFilterCreationDateInput="ngModel"
          inputId="task-filter-creationDate"
          name="task-filter-creationDate"
          appendTo="body"
          [(ngModel)]="dataFilters.values.creationDate"
          selectionMode="range"
          showIcon
          iconDisplay="input"
          [showButtonBar]="true"
        />
        <label for="task-filter-creationDate">
          {{ t("creation") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="dataFilters.values = {}; refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG 2 --------------------------------->
  <p-dialog
    [header]="t(FILTERS_TITLE2)"
    [(visible)]="filtersDialogVisible2"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide2()"
  >
    <form class="filter-form" #filterForm2="ngForm">
      <!--? STATUS ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #automationFilterTriggerTypeInput="ngModel"
          inputId="automation-filter-triggerType"
          name="automation-filter-triggerType"
          appendTo="body"
          [options]="
            translateObjectValues(
              dataFilters2.options.triggerType,
              'description',
              { value: 'N' }
            )
          "
          [(ngModel)]="dataFilters2.values.triggerType"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
          optionLabel="description"
          optionValue="code"
        />
        <label for="automation-filter-triggerType">
          {{ t("triggerType") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="dataFilters2.values = {}; refreshData2()"
        [disabled]="(dataLoading2$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData2()"
        [disabled]="(dataLoading2$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>
</ng-container>
